import {ComumService} from '../comum/comum.service';
import {DadoTransacional} from '../comum/modelos/dado-transacional';
import {Injectable} from '@angular/core';
import {SettingsService} from '../settings.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {of} from 'rxjs/observable/of';
import {Observable} from 'rxjs/Observable';
import {catchError, map, tap} from 'rxjs/operators';

@Injectable()
export class ConstrucaoVariaveisService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient,
    private _comumService: ComumService) {
    this._host = this._settingsService.obterHostBase() + '/variaveis/';
  }

  obterDadosTransacionaisClienteHttp(id: number): Observable<DadoTransacional[]> {
    return this._http.get(this._host + 'dado-transacional/cliente/' + id)
      .catch(this.handleError);
  }

  removerDadoTransacionalHttp(idDadoTransacional: number): Observable<HttpResponse<DadoTransacional>> {
    return this._http
      .delete(this._host + idDadoTransacional, {
        observe: 'response'
      }).catch(this.handleError);
  }

  cadastrarDadoTransacionalHttp(dadoTransacional: DadoTransacional): Observable<HttpResponse<DadoTransacional>> {
    return this._http
      .post(this._host + 'dado-transacional/', dadoTransacional, {
        observe: 'response'
      }).catch(this.handleError);
  }

  atualizarDadoTransacionalHttp(dadoTransacional: DadoTransacional): Observable<HttpResponse<DadoTransacional>> {
    return this._http
      .put(this._host + 'dado-transacional/', dadoTransacional, {
        observe: 'response'
      }).catch(this.handleError);
  }

  obterDadoTransacionalPorIdHttp(id: number): Observable<DadoTransacional> {
    return this._http.get(this._host + 'dado-transacional/' + id)
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/construcao-variaveis.service.ts